import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 寄棟説明ダイアログ
 * 軒・妻設定の方法について説明
 */
class RoofGuidanceYosemune extends Dialog {
  /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);
    const self = this;

    const id = 'dialogRoof2';
    let title = '';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en': title = 'Hip and Gable Setting'; break;
      default: title = '軒・妻設定'; break;
    }

    const descImg1 = new Image();
    descImg1.src = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}description_roof_yosemune.jpg`;
    descImg1.addEventListener('load', function imageLoad() {
      document.getElementById('descImg1').appendChild(this);
      self.centerDialog();
    });

    let contents = '';

    // 説明画面
    contents += '<div class="roofGuidance2">\n';
    contents += '<ol>\n';
    contents += '<li>\n';
    contents += '<div class="title"><span class="jp">桁線をクリックして軒・妻設定を行います。</span><span class="en">Click the sides to set the shape of the roof.</span></div>\n';
    contents += '<div class="descImg" id="descImg1">\n';
    contents += '</div>\n';
    contents += '</li>\n';
    contents += '</ol>\n';

    contents += '</div>\n';

    let footer = '';
    footer += '<button id="btnDialogRoofCancel"><span class="jp">閉じる</span><span class="en">Close</span></button>\n';

    this.createDialog(id, title, contents, footer);

    document.getElementById('btnDialogRoofCancel').addEventListener('click', self.close);
  }
}
export default RoofGuidanceYosemune;
